// extracted by mini-css-extract-plugin
export default {"content":"Login_content__DBIt4","formBgr":"Login_formBgr__RwXLZ","formTitle":"Login_formTitle__lLCAo"};